import React, { FC } from 'react';

type CampaignsCreditPackageCardProps = {
  title: string;
  messages: string;
  price: string;
  features: string[];
  ctaLabel: string;
  isPopular?: boolean;
};

export const CampaignsCreditPackageCard: FC<CampaignsCreditPackageCardProps> = ({ title, messages, price, features, ctaLabel, isPopular = false }) => {
  return (
    <article
      className={`relative flex min-w-[220px] flex-col rounded-2xl border bg-white p-5 shadow-sm ${
        isPopular ? 'border-primary-400 ring-2 ring-primary-100' : 'border-secondary-border'
      }`}
    >
      {isPopular ? (
        <span className='absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary-600 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white-100'>
          Most Popular
        </span>
      ) : null}

      <p className='text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{title}</p>
      <p className='mt-2 text-3xl font-semibold text-slate-900'>{messages}</p>
      <p className='text-xs text-secondary-500'>messages</p>
      <p className='mt-3 text-xl font-semibold text-primary-700'>{price}</p>

      <ul className='mt-4 space-y-2 text-sm text-secondary-600'>
        {features.map((feature) => (
          <li key={feature} className='flex items-start gap-2'>
            <span className='mt-1 h-1.5 w-1.5 rounded-full bg-secondary-400' />
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <button
        type='button'
        className={`mt-5 h-10 rounded-lg border px-3 text-sm font-semibold transition-colors ${
          isPopular ? 'border-primary-600 bg-primary-600 text-white-100 hover:bg-primary-700' : 'border-secondary-border text-slate-800 hover:bg-gray-50'
        }`}
      >
        {ctaLabel}
      </button>
    </article>
  );
};
